import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledInlineContact from './InlineContact.style.js';

const InlineContact = (_ref) => {
  let {
    mail,
    label
  } = _ref,
      props = _objectWithoutProperties(_ref, ["mail", "label"]);

  return /*#__PURE__*/React$1.createElement(StyledInlineContact, props, /*#__PURE__*/React$1.createElement("div", {
    className: "inlineContact__wrapper"
  }, /*#__PURE__*/React$1.createElement(Link$1, {
    href: `mailto:${mail}`,
    component: "a",
    icon: "contact"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "span",
    transform: "uppercase",
    hasAccent: true
  }, label))));
};

InlineContact.propTypes = {
  mail: PropTypes$1.string.isRequired,
  label: PropTypes$1.string.isRequired
};
InlineContact.defaultProps = {};

export default InlineContact;
